import { useQuery } from '@tanstack/react-query';
import { fetchTenantConfig } from './configApi';
import { fetchBranches } from './branches';

export const useTenantConfigQuery = () => {
  return useQuery({
    queryKey: ['tenantConfig'],
    queryFn: fetchTenantConfig,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};

export const useBranchesQuery = () => {
  const { data: tenantConfig } = useTenantConfigQuery();
  const enterpriseId = tenantConfig?.enterprise_id;

  return useQuery({
    queryKey: ['branches', enterpriseId],
    queryFn: () => fetchBranches(enterpriseId),
    enabled: !!enterpriseId,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};